import { Grid, Typography, useTheme } from "@mui/material";
import React from "react";
import { DefaultExtensionType, FileIcon } from "react-file-icon";
import { useTranslation } from "react-i18next";
import { customFileIconStyles } from "src/reusable-components/DefaultFileIconStyles/default-file-icon-styles";
import { UploadedFileProps as Props } from "./interfaces";
import { FileIconButton } from "../AttachedFiles/styles";

const UploadedFile = ({
  file,
  viewThisFile,
  index,
  saveDocumentError,
  saveFileError,
  saveOutgoingMailError,
  attemptedToSave,
}: Props) => {
  const { t } = useTranslation();
  const tRP = "components.add_outgoing_mail.uploaded_files";
  const theme = useTheme();
  return (
    <Grid style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
      <Grid style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <Typography
          style={{
            width: "35px",
            textWrap: "nowrap",
          }}
        >
          {`#${index + 1}`} :
        </Typography>
        <FileIconButton onClick={() => viewThisFile(file)}>
          <FileIcon
            extension={file.fileExtension}
            {...customFileIconStyles[file.fileExtension as DefaultExtensionType]}
          />
        </FileIconButton>
        <Typography>{file.fileName}</Typography>
      </Grid>
      {attemptedToSave && (saveDocumentError || saveFileError || saveOutgoingMailError) && (
        <Typography
          variant="body2"
          style={{ color: theme.palette.error.main }}
        >
          {saveDocumentError
            ? `${t(`${tRP}.error_saving_document`)} : ${saveDocumentError}`
            : saveFileError
            ? `${t(`${tRP}.error_saving_file`)} : ${saveFileError}`
            : saveOutgoingMailError && `${t(`${tRP}.error_saving_outgoing_mail`)} : ${saveOutgoingMailError}`}
        </Typography>
      )}
    </Grid>
  );
};

export default UploadedFile;
